export enum LoginMethod {
  SSO = "SSO",
  MagicLink = "MAGIC_LINK",
  Password = "PASSWORD",
}
